import { ObterRelatorio } from "./metodos/ObterRelatorio";

export const RelatoriosService = {
    ObterRelatorio
}